export const procent = (BankCommision, Summ, Days, yearProcent) => {
  // Формулы расчета (результат округляем по правилам математики до 2 знаков после запятой):




  Summ = Number(
    String(Summ)
      .replace(/\s|\s+/g, "")
      .replace(",", ".")
  ).toFixed(2);

  const years = () => {
    // % годовых = Комиссия банка * 36500 / Сумма БГ / Срок БГ
    // Например, при комиссии 80 000 руб. для БГ на 1 000 000 руб. сроком 900 дней результат расчета будет "3,24% годовых"
    return `${((Number(parseFloat(BankCommision)) * 36500) / Number(parseFloat(Summ)) / Number(parseInt(Days)))
      .toFixed(2)
      .toLocaleString("ru")
      .replace(".", ",")}% годовых`;
  };
  const fixed = () => {
    // % фиксированный = Комиссия банка *100 / Сумма БГ
    // Например, при комиссии 15 000 руб. для БГ 1 000 000 руб. сроком 180 дней результат расчета будет "1,5%"
    return `${((Number(parseFloat(BankCommision)) * 100) / Number(parseFloat(Summ)))
      .toFixed(2)
      .toLocaleString("ru")
      .replace(".", ",")}%`;
  };

  // В зависимости от срока БГ:
  // - выводим % годовых (если срок БГ больше 365 дней),
  // - выводим % фиксированный (если срок БГ равен или меньше 365 дней)
  return yearProcent ? years() : fixed();
};
